import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { UserAllowedClaimsModel } from '../../Models/Domains/Users/UserAllowedClaimsModel';

declare var IS_RUNNING_IN_APP_POOL;

export class UserAllowedClaimsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<UserAllowedClaimsModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/UserAllowedClaims/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<UserAllowedClaimsModel, any>(url, data);
  }
}

